import { useState, type MutableRefObject } from "react"
import { startOfMonth } from "date-fns"
import Button from "@/v2-backoffice-client/components/button"
import DateRangePickerNav from "./DateRangePickerNav"
import { useDateRangePickerContext } from "./dateRangePicker.context"

type DateRangePickerNavBarProps = {
  initialMonth: Date
  setNavMonthRef: MutableRefObject<(month: Date) => void>
  onNavigate(month: Date): void
}

function DateRangePickerNavBar(props: DateRangePickerNavBarProps) {
  const { initialMonth, setNavMonthRef, onNavigate } = props
  const { mode, start, end } = useDateRangePickerContext()

  const [displayMonth, setDisplayMonth] = useState(initialMonth)
  setNavMonthRef.current = setDisplayMonth

  const hasStart = !!start
  const hasEnd = !!end

  return (
    <div className="ui-date-picker-nav">
      <DateRangePickerNav month={displayMonth} onMonthChange={onNavigate} />

      <div className="ui-date-picker-nav-jumps">
        <Button
          variant="ghost"
          size="xs"
          className="ui-date-picker-nav-jump"
          onClick={() => onNavigate(startOfMonth(new Date()))}
        >
          Today
        </Button>

        {mode === "within" ? (
          <>
            <Button
              variant="ghost"
              size="xs"
              className="ui-date-picker-nav-jump"
              disabled={!hasStart}
              onClick={() => start && onNavigate(startOfMonth(start))}
            >
              Start
            </Button>
            <Button
              variant="ghost"
              size="xs"
              className="ui-date-picker-nav-jump"
              disabled={!hasEnd}
              onClick={() => end && onNavigate(startOfMonth(end))}
            >
              End
            </Button>
          </>
        ) : (
          <Button
            variant="ghost"
            size="xs"
            className="ui-date-picker-nav-jump"
            disabled={mode === "before" ? !hasEnd : !hasStart}
            onClick={() => {
              const target = mode === "before" ? end : start
              if (target) onNavigate(startOfMonth(target))
            }}
          >
            Selected
          </Button>
        )}
      </div>
    </div>
  )
}

export default DateRangePickerNavBar
